module.exports = __webpack_public_path__ + "6932b8cc7c7f95d3661c03ee394fd923.pdf";